import React, { Component, PropTypes } from "react";
import Header from "../Header"

export default class Page extends Component {
  counter = 0;

  static propTypes = {
    title: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    background: PropTypes.string,
  };

  componentDidMount() {
    this.goToTop()
  }

  componentDidUpdate() {
    this.goToTop()
  }

  goToTop() {
    const top = window.pageYOffset;
    if (top <= 0) {
      this.counter = 0;
      return;
    }
    this.counter += 1;
    window.scrollTo(0, top - this.counter);
    setTimeout(() => {
      this.goToTop();
    }, 1);
  }

  render() {
    const { title, header, children, ...props } = this.props;

    document.title = title;
    return (
      <section>
        <Header {...props}>
          {header}
        </Header>
        {children}
      </section>
    )
  }
};




// WEBPACK FOOTER //
// ./src/components/Page/index.js